import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class RecoverPasswordService {

  constructor(private _http: HttpClient) {}

  recoverPassword({ email }) {
    const normalizedEmail = String(email || '').trim().toLowerCase();
    return this
      ._http
      .post(`${environment.apiUrl}/common/auth/recover`, { email: normalizedEmail })
      .toPromise();
  }

}